const Home = () => {
  return (
    <>
      <h1>Welcome to CRS CRM system</h1>
    </>
  )
}

export default Home
